import axios from 'axios';
import { ApiUtil } from '../..';

export const lcmsApi = {
    /** 콘텐츠 - 출제 범위 조회 */
    getLesnRscMdulExamScopeL: (param: API.LesnRscMdulExamScope.Req) => {
        return ApiUtil.lcms_get<API.LesnRscMdulExamScope.Res>(
            '/api/system/meta/descendants/' + param.setsId,
            {}
        );
    },

    /** 콘텐츠 - 세트지 정보 검색 (setId 로 articleList 조회) */
    postLesnRscSetSummaryList: (param: API.LesnRscSetSummaryList.Req) => {
        return axios.post<API.LesnRscSetSummaryList.Res>(
            import.meta.env.VITE_AIDT_URL_LCMSAPI + '/api/contents/setSummarylist',
            param
        );
    },

    getBrandId: () => {
        return axios.get<API.BrandDataInfo.Res>(
            import.meta.env.VITE_AIDT_URL_LCMSAPI + '/api/system/brandlist'
        );
    },
};
